import { landingTrackerServiceModule } from '../../services/landing-tracker-service';

export const landingTrackClickComponentModule = angular
  .module('Q.components.track-click', [landingTrackerServiceModule])
  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name trackClick
   * @description
   * Tracks a click on an element
   *
   * @restrict A
   * @element ANY
   * @param {string} trackClick String to use as the tracked event name, not interpolated
   * @param {expression=} trackData Hash of key-values to store with the track
   *
   * @example
   * <example>
   * <a track-click="event.name" track-data="{ properties }"></a>
   * </example>
   */
  .directive('trackClick', function (trackerService) {
    return {
      restrict: 'A',
      replace: false,
      link: function (scope, elem, attrs) {
        elem.on('click', function () {
          trackerService.trackEvent(
            attrs.trackClick,
            attrs.trackData ? scope.$eval(attrs.trackData) : null,
          );
        });
      },
    };
  });
